import { useCallback, useRef, useState } from 'react';
import { notifications } from '@mantine/notifications';
import { paymentsService } from '../../../../../services/payments/payments.service';

type Params = {
  tenantId: string;
  employeeSession: string | null;
  paymentlineId: number;
};

// One in-flight finish per line; the closed order arrives through the POS SSE deltas.
export function useCibusFinishOrder({ tenantId, employeeSession, paymentlineId }: Params) {
  const [isFinishing, setIsFinishing] = useState(false);
  const inFlightRef = useRef(false);

  const finish = useCallback(async () => {
    if (!employeeSession || inFlightRef.current) {
      return;
    }
    inFlightRef.current = true;
    setIsFinishing(true);
    try {
      await paymentsService.finishCibus(tenantId, paymentlineId, employeeSession);
    } catch (error: unknown) {
      notifications.show({
        color: 'red',
        title: 'סיבוס',
        message: error instanceof Error ? error.message : 'סגירת ההזמנה נכשלה',
        autoClose: 4000,
      });
    } finally {
      inFlightRef.current = false;
      setIsFinishing(false);
    }
  }, [employeeSession, paymentlineId, tenantId]);

  return { isFinishing, finish };
}
